import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import { Color } from './color';

export interface Fabric extends BaseEntity {
  name: string;
  isChasubleBody: boolean | null;
  isChasublePanel: boolean | null;
  isAlbBody: boolean | null;
  isStolePanel: boolean | null;
  isStolePatching: boolean | null;
  isMitreBody: boolean | null;
  isMitrePanel: boolean | null;
  isMitreLining: boolean | null;
  colors: Color[];
  sortOrder?: number;
}

export interface CreateFabricData {
  name: string;
  isChasubleBody?: boolean;
  isChasublePanel?: boolean;
  isAlbBody?: boolean;
  isStolePanel?: boolean;
  isStolePatching?: boolean;
  isMitreBody?: boolean;
  isMitrePanel?: boolean;
  isMitreLining?: boolean;
  colors?: number[];
}

export type UpdateFabricData = Partial<CreateFabricData>;

const fabricApi = createCrudApi<Fabric, CreateFabricData, UpdateFabricData>(
  'fabric'
);

export const getAllFabrics = fabricApi.getAll;
export const getFabricById = fabricApi.getById;
export const createFabric = fabricApi.create;
export const updateFabric = fabricApi.update;
export const deleteFabric = fabricApi.delete;
export const reorderFabrics = fabricApi.reorder;
